module.exports = __webpack_public_path__ + "static/img/IR.fca174c4.svg";